module.exports = __webpack_public_path__ + "assets/img/烟感.b5c2bc90.jpg";